module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Design/Select-dc7c738dd5660584b9e6991ecf2c6fd0.svg";